// extracted by mini-css-extract-plugin
export default {"moreItemsIndicator":"RXcFB+XEg4zvrCHbEDrxfg=="};